import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl, defineMessages } from 'react-intl';
// import { Map, List, fromJS } from 'immutable';

import { Segment, Grid, Icon, List, Message, Input, Dropdown, Image, Popup } from 'semantic-ui-react';
import { Tooltip, Switch, FormControlLabel, Checkbox, IconButton } from 'material-ui';

import { Button, ModalAlert } from 'components';

import * as commonVar from 'libs/commonVar';

import styles from './ExamSearch.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ExamSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      popupOpen: false
    }
  }

  // 훈련 결과 입력
  handleChangeSearchText = e => {
    const { takeSearchValue } = this.props;
    takeSearchValue(e.target.value);
  };

  // 필터 팝업 열기/닫기
  handlePopup = value => {
    this.setState({
      popupOpen: value
    });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      isModal,
      className,
      examNo,
      examListParam,
      examSubTab,
      examSearchProps,
      selectedExamList,
      examType,
      dropDirection,
      searchTextRef,
      tempFilter
    } = this.props;
    // 훈련 삭제
    const { loadingExamDelete, onExamDeleteModal, onToggleModal } = this.props;

    const { handlePopup } = this;
    const { popupOpen } = this.state;

    // 정렬
    const sortOptions = [
      // 공통
      {
        text: defineMessages(formatMessage({ id: 'ExamSearch_30', defaultMessage: '위험 대상자' })),
        value: 'infection'
      },
      { text: defineMessages(formatMessage({ id: 'ExamSearch_2', defaultMessage: '발송' })), value: 'send' },
      {
        text: defineMessages(formatMessage({ id: 'ExamSearch_27', defaultMessage: '발송 예약' })),
        value: 'sendReserve'
      },
      { text: defineMessages(formatMessage({ id: 'ExamSearch_3', defaultMessage: '열람' })), value: 'read' },
      { text: defineMessages(formatMessage({ id: 'ExamSearch_28', defaultMessage: '피싱 접속' })), value: 'connect' },
      { text: defineMessages(formatMessage({ id: 'ExamSearch_29', defaultMessage: '정보 유출' })), value: 'phishing' },
      { text: defineMessages(formatMessage({ id: 'CtExamChart_5', defaultMessage: '파일 다운' })), value: 'fileDown' },
      { text: defineMessages(formatMessage({ id: 'ExamSearch_4', defaultMessage: '감염' })), value: 'fileInfection' },
      { text: defineMessages(formatMessage({ id: 'ExamSearch_5', defaultMessage: '감염 PC' })), value: 'infectionPc' },
      { text: defineMessages(formatMessage({ id: 'CtExamChart_7', defaultMessage: '치료' })), value: 'cure' },
      { text: defineMessages(formatMessage({ id: 'ExamDetailTag_17', defaultMessage: '이메일' })), value: 'targetEmail' },
      { text: defineMessages(formatMessage({ id: 'ExamDetailTag_27', defaultMessage: '이름' })), value: 'targetName' }
      // {
      //   text: defineMessages(formatMessage({ id: 'ExamSearch_6', defaultMessage: '전체 감염 개수' })),
      //   value: 'leakAllcount'
      // },
      // {
      //   text: defineMessages(formatMessage({ id: 'ExamSearch_7', defaultMessage: '전체 감염 크기' })),
      //   value: 'leakAllsize'
      // },
      // {
      //   text: defineMessages(formatMessage({ id: 'ExamSearch_8', defaultMessage: '파일 개수' })),
      //   value: 'leakFileCount'
      // },
      // {
      //   text: defineMessages(formatMessage({ id: 'ExamSearch_9', defaultMessage: '파일 크기' })),
      //   value: 'leakFileSize'
      // },
      // {
      //   text: defineMessages(formatMessage({ id: 'ExamSearch_10', defaultMessage: '인증서 개수' })),
      //   value: 'leakCertCount'
      // },
      // {
      //   text: defineMessages(formatMessage({ id: 'ExamSearch_11', defaultMessage: '인증서 크기' })),
      //   value: 'leakCertSize'
      // },
      // {
      //   text: defineMessages(formatMessage({ id: 'ExamSearch_12', defaultMessage: '이메일 개수' })),
      //   value: 'leakEmailCount'
      // },
      // {
      //   text: defineMessages(formatMessage({ id: 'ExamSearch_13', defaultMessage: '이메일 크기' })),
      //   value: 'leakEmailSize'
      // }
    ];

    let sortedOptions = [];
    if (examType === 4) {
      sortedOptions = sortOptions.slice(1, 6).concat(sortOptions.slice(10,18));
    } else if (examType === 1) {
      sortedOptions = sortOptions.slice(1, 4).concat(sortOptions.slice(6, 18));
    } else if (examType === undefined) {
      sortedOptions = sortOptions.splice(0, 10);
    }

    // // 전체 훈련
    // if (examSubTab === 'all') {
    //   sortOptions = [{ text: '훈련 번호', value: 'examNo' }, { text: '훈련명', value: 'examName' }].concat(sortOptions);
    //   // 대상
    // } else if (examSubTab === 'pi') {
    //   sortOptions = [
    //     { text: '대상자 번호', value: 'targetNo' },
    //     { text: '대상자 이름', value: 'targetName' },
    //     { text: '대상자 이메일', value: 'targetEmail' }
    //   ].concat(sortOptions);
    //   // 태그
    // } else if (examSubTab === 'tag') {
    //   sortOptions = [{ text: '태그 번호', value: 'tagNo' }, { text: '태그명', value: 'tagName' }].concat(sortOptions);
    // }

    const isFiltered = Object.keys(examListParam.get('filter').toJS()).length > 0 ? true : false;
    const filterList = [
      {
        enable: false,
        name: 'target',
        text: defineMessages(formatMessage({ id: 'ExamSearch_1', defaultMessage: '대상' }))
      },
      {
        enable: true,
        name: 'infection',
        text: defineMessages(formatMessage({ id: 'ExamSearch_30', defaultMessage: '위험 대상자' }))
      },
      {
        enable: true,
        name: 'send',
        text: defineMessages(formatMessage({ id: 'ExamSearch_2', defaultMessage: '발송' }))
      },
      {
        enable: true,
        name: 'sendReserve',
        text: defineMessages(formatMessage({ id: 'ExamSearch_27', defaultMessage: '발송 예약' }))
      },
      {
        enable: true,
        name: 'sendError',
        text: defineMessages(formatMessage({ id: 'ExamSearch_25', defaultMessage: '발송 실패' }))
      },
      {
        enable: true,
        name: 'read',
        text: defineMessages(formatMessage({ id: 'ExamSearch_3', defaultMessage: '열람' }))
      },
      {
        enable: true,
        name: 'connect',
        text: defineMessages(formatMessage({ id: 'ExamSearch_28', defaultMessage: '피싱 접속' }))
      },
      {
        enable: true,
        name: 'phishing',
        text: defineMessages(formatMessage({ id: 'ExamSearch_29', defaultMessage: '정보 유출' }))
      },
      {
        enable: true,
        name: 'fileDown',
        text: defineMessages(formatMessage({ id: 'CtExamChart_5', defaultMessage: '파일다운' }))
      },
      {
        enable: true,
        name: 'fileInfection',
        text: defineMessages(formatMessage({ id: 'ExamSearch_4', defaultMessage: '감염' }))
      },
      {
        enable: true,
        name: 'cure',
        text: defineMessages(formatMessage({ id: 'CtExamChart_7', defaultMessage: '치료' }))
      },
      {
        enable: false,
        name: 'searchAll',
        text: defineMessages(formatMessage({ id: 'ExamSearch_17', defaultMessage: '검색' }))
      }
    ];
    //   // 전체 훈련 여부
    //   const isExamAll = examNo === 'all';
    // // 피싱
    // examType === 4

    let filteredList = [];
    if (examType === 4) {
      filteredList = filterList.slice(2, 8);
    } else if (examType === 1) {
      filteredList = filterList.slice(2, 6).concat(filterList.slice(8, 16));
    } else if (examType === undefined) {
      filteredList = filterList;
    }

    const infectionList = [
      {
        enable: true,
        name: 'infectionPc',
        text: defineMessages(formatMessage({ id: 'ExamSearch_5', defaultMessage: '감염 PC' }))
      },
      {
        enable: true,
        name: 'leakFileCount',
        text: defineMessages(formatMessage({ id: 'ExamSearch_23', defaultMessage: 'PC 파일' }))
      },
      {
        enable: true,
        name: 'leakCertCount',
        text: defineMessages(formatMessage({ id: 'ExamSearch_15', defaultMessage: '인증서' }))
      },
      {
        enable: true,
        name: 'leakEmailCount',
        text: defineMessages(formatMessage({ id: 'ExamSearch_16', defaultMessage: '이메일' }))
      }
    ];

    const filterTextInner = [];
    filterList.map(data => {
      !!examListParam.getIn(['filter', data.name]) && filterTextInner.push(data.text);
    });
    const filterText = isFiltered
      ? defineMessages(formatMessage({ id: 'ExamSearch_18', defaultMessage: '필터' })) +
      ': ' +
      filterTextInner.join(', ')
      : defineMessages(formatMessage({ id: 'ExamSearch_18', defaultMessage: '필터' }));

    // 전체 훈련 여부
    const isExamAll = examNo === 'all';

    const checkIcon = selectedExamList.get('isAllCheckExamList');
    // let checkedIcon;
    // if (checkIcon === 1) {
    //   checkedIcon = <img src="/img/exam/list_check_on.png" />;
    // } else if (checkIcon === 3) {
    //   checkedIcon = <img src="/img/exam/list_check_each.png" />;
    // }

    const examFilterList = (
      <Dropdown.Menu>
        <Dropdown.Header
          content={defineMessages(formatMessage({ id: 'ExamTemplateList_30', defaultMessage: '훈련 결과' }))}
        />
        {filteredList.map((data, index) => {
          if (data.enable) {
            return (
              <Dropdown.Item
                key={index}
                value={data.name}
                onClick={(e, props) => {
                  e.stopPropagation();
                  examSearchProps.onFilterItem(props);
                }}>
                <div className={cx('check-box')}>
                  <Image
                    className={!!tempFilter[data['name']] ? 'checkmark box' : 'outline box'}
                    src="/img/target/ico-check.png"
                  />
                </div>
                <div className={cx('box-text')}>{data.text}</div>
              </Dropdown.Item>
            );
          }
        })}
      </Dropdown.Menu>
    );

    const infectionFilterList = (
      <Dropdown.Menu>
        <Dropdown.Header
          content={defineMessages(formatMessage({ id: 'ExamDetail_26', defaultMessage: '감염 정보' }))}
        />
        <Dropdown.Divider />
        {infectionList.map((data, index) => {
          if (data.enable) {
            return (
              <Dropdown.Item
                key={index}
                value={data.name}
                onClick={(e, props) => {
                  e.stopPropagation();
                  examSearchProps.onFilterItem(props);
                }}>
                <div className={cx('check-box')}>
                  <Image
                    className={!!tempFilter[data['name']] ? 'checkmark box' : 'outline box'}
                    src="/img/target/ico-check.png"
                  />
                </div>
                <div className={cx('box-text')}>{data.text}</div>
              </Dropdown.Item>
            );
          }
        })}
      </Dropdown.Menu>
    );

    const filterExamArray = [];
    const filterPCArray = [];
    const filterLength = Object.keys(examListParam.get('filter').toJS());
    if (filterLength.length > 0) {
      filterLength.map((filter, index) => {
        if (filter === 'infection') {
          filterExamArray.push(defineMessages(formatMessage({ id: 'ExamSearch_30', defaultMessage: '위험 대상자' })));
        } else if (filter === 'send') {
          filterExamArray.push(defineMessages(formatMessage({ id: 'ExamSearch_2', defaultMessage: '발송' })));
        } else if (filter === 'sendReserve') {
          filterExamArray.push(defineMessages(formatMessage({ id: 'ExamSearch_27', defaultMessage: '발송 예약' })));
        } else if (filter === 'sendError') {
          filterExamArray.push(defineMessages(formatMessage({ id: 'ExamSearch_25', defaultMessage: '발송 실패' })));
        } else if (filter === 'read') {
          filterExamArray.push(defineMessages(formatMessage({ id: 'ExamSearch_3', defaultMessage: '열람' })));
        } else if (filter === 'connect') {
          filterExamArray.push(defineMessages(formatMessage({ id: 'ExamSearch_28', defaultMessage: '피싱 접속' })));
        } else if (filter === 'phishing') {
          filterExamArray.push(defineMessages(formatMessage({ id: 'ExamSearch_29', defaultMessage: '정보 유출' })));
        } else if (filter === 'fileDown') {
          filterExamArray.push(defineMessages(formatMessage({ id: 'CtExamChart_5', defaultMessage: '파일 다운' })));
        } else if (filter === 'fileInfection') {
          filterExamArray.push(defineMessages(formatMessage({ id: 'ExamSearch_4', defaultMessage: '감염' })));
        } else if (filter === 'cure') {
          filterExamArray.push(defineMessages(formatMessage({ id: 'CtExamChart_7', defaultMessage: '치료' })));
        } else if (filter === 'infectionPc') {
          filterPCArray.push(defineMessages(formatMessage({ id: 'ExamSearch_5', defaultMessage: '감염 PC' })));
        } else if (filter === 'leakFileCount') {
          filterPCArray.push(defineMessages(formatMessage({ id: 'ExamSearch_23', defaultMessage: 'PC 파일' })));
        } else if (filter === 'leakCertCount') {
          filterPCArray.push(defineMessages(formatMessage({ id: 'ExamSearch_15', defaultMessage: '인증서' })));
        } else if (filter === 'leakEmailCount') {
          filterPCArray.push(defineMessages(formatMessage({ id: 'ExamSearch_16', defaultMessage: '이메일' })));
        }
      });
    }

    // 툴팁 정보
    const tooltipInfo = (
      <div className={cx('tooltip-wrapper')}>
        <div className={cx('arrow')} />

        {filterExamArray.length > 0 && (
          <div className={cx('tooltip-row')}>
            <div className={cx('tooltip-title')}>
              <span className={cx('title-dot')} />
              {defineMessages(formatMessage({ id: 'ExamTemplateList_30', defaultMessage: '훈련 결과' }))}
            </div>
            <span className={cx('tooltip-context')}>{filterExamArray.join(', ')}</span>
          </div>
        )}
        {filterPCArray.length > 0 && (
          <div className={cx('tooltip-row')}>
            <div className={cx('tooltip-title')}>
              <span className={cx('title-dot')} />
              {defineMessages(formatMessage({ id: 'ExamDetail_26', defaultMessage: '감염 정보' }))}
            </div>
            <span className={cx('tooltip-context')}>{filterPCArray.join(', ')}</span>
          </div>
        )}
      </div>
    );

    return (
      <Segment className={cx(className)} vertical>
        <Grid columns="equal" stackable>
          <Grid.Row textAlign="left" className={cx('search-area')}>
            <div className={cx('search-colum')}>
              {examSubTab === 'all' && (
                <FormControlLabel
                  className={cx('all-checkbox')}
                  control={
                    <Checkbox
                      className={cx('examListItem-checkBox')}
                      onChange={examSearchProps.handleCheckAllExamList}
                      checked={checkIcon === 1 ? true : false}
                      indeterminate={checkIcon === 3 ? true : false}
                      checkedIcon={checkIcon === 1 ? <img src="/img/exam/list_check_on.png" /> : null}
                      indeterminateIcon={checkIcon === 3 ? <img src="/img/exam/list_check_each.png" /> : null}
                    />
                  }
                  label={
                    checkIcon === 1
                      ? defineMessages(formatMessage({ id: 'Target_8', defaultMessage: '전체해제' }))
                      : defineMessages(formatMessage({ id: 'Target_9', defaultMessage: '전체선택' }))
                  }
                />
              )}
              {/* 훈련 삭제 */}
              {!!isExamAll && (
                <Tooltip
                  title={
                    selectedExamList.get('noArray').size > 0
                      ? defineMessages(
                        formatMessage({
                          id: 'ExamHeader_25',
                          defaultMessage: '선택한 훈련 삭제하기'
                        })
                      )
                      : defineMessages(
                        formatMessage({
                          id: 'ExamHeader_11',
                          defaultMessage: '훈련을 선택하세요'
                        })
                      )
                  }
                  placement="bottom">
                  <div className={cx('inline-block')}>
                    <Button
                      className={cx('bt-delete')}
                      size="mini"
                      buttonColor="#dddddd"
                      fontSize="13"
                      fontColor="#757575"
                      disabled={selectedExamList.get('noArray').size > 0 ? false : true}
                      onClick={() => {
                        onToggleModal('isExamDelete');
                      }}>
                      {/* <Icon name="delete" /> */}
                      {defineMessages(formatMessage({ id: 'CtExamSummary_5', defaultMessage: '훈련 삭제' }))}
                    </Button>
                  </div>
                </Tooltip>
              )}
              {/* 훈련삭제 모달 경고창 */}
              {isModal === 'isExamDelete' && (
                <ModalAlert
                  visible
                  isClicked={loadingExamDelete}
                  headerTitle={defineMessages(formatMessage({ id: 'CtExamSummary_5', defaultMessage: '훈련 삭제' }))}
                  onConfirm={onExamDeleteModal}
                  onToggleModal={onToggleModal}>
                  <div className={cx('message-header')}>
                    {defineMessages(
                      formatMessage({
                        id: 'ModalExamDelete_4',
                        defaultMessage: '삭제한 훈련은 복구할 수 없습니다.'
                      })
                    )}
                    <br />
                    {defineMessages(
                      formatMessage({
                        id: 'ModalExamDelete_9',
                        defaultMessage: '다음 훈련을 삭제합니까?'
                      })
                    )}
                  </div>
                  <Message className={cx('template-detail-box')}>
                    <div className={cx('template-detail')}>
                      <List bulleted className={cx('template-detail-list')}>
                        <List.Item className={cx('template-detail-item')}>
                          <div className={cx('template-detail-item-title')}>
                            {defineMessages(formatMessage({ id: 'ModalExamDelete_5', defaultMessage: '훈련 번호' }))}
                          </div>
                          {selectedExamList
                            .get('noArray')
                            .toJS()
                            .join(', ')}
                        </List.Item>
                        {/* <List.Item className={cx('template-detail-item')}>
                          <div className={cx('template-detail-item-title')}>
                            {defineMessages(formatMessage({ id: 'ModalExamDelete_6', defaultMessage: '훈련명' }))}
                          </div>
                          {isEditExamData.get('examName')}
                        </List.Item> */}
                      </List>
                    </div>
                  </Message>
                </ModalAlert>
              )}
              {typeof examNo === 'number' &&
                examSubTab === 'pi' && (
                  <Tooltip
                    title={defineMessages(
                      formatMessage({
                        id: 'ExamSearch_26',
                        defaultMessage: '현재 훈련의 필터링된 대상자를 태그로 등록합니다.'
                      })
                    )}
                    placement="top-start">
                    <Button
                      className={cx('bt-addTag')}
                      size="mini"
                      buttonColor="#dddddd"
                      fontColor="#757575"
                      onClick={() => {
                        examSearchProps.onToggleModal('examAddTag');
                      }}>
                      <Icon name="add square" />
                      {defineMessages(formatMessage({ id: 'ModalTagAdd_1', defaultMessage: '태그 만들기' }))}
                    </Button>
                  </Tooltip>
                )}
            </div>
            <div className={cx('search-colum')}>
              {/* --------------------------------- 정렬 --------------------------------- */}
              <Tooltip
                title={
                  examListParam.get('sort')[0]['order'] === 'DESC'
                    ? defineMessages(formatMessage({ id: 'ExamSearch_19', defaultMessage: '오름차순으로 변경' }))
                    : defineMessages(formatMessage({ id: 'ExamSearch_20', defaultMessage: '내림차순으로 변경' }))
                }
                placement="top">
                <Button
                  className={cx('bt-examSort')}
                  size="mini"
                  buttonColor="#dddddd"
                  fontColor="#757575"
                  onClick={examSearchProps.onSortOrdering}
                  icon={
                    examListParam.get('sort')[0]['order'] === 'DESC' ? (
                      <img src="/img/exam/list_descending.png" />
                    ) : (
                        <img src="/img/exam/list_ascending.png" />
                      )
                  }
                />
              </Tooltip>
              <Tooltip
                title={defineMessages(formatMessage({ id: 'ExamSearch_21', defaultMessage: '정렬 방법 선택' }))}
                placement="top">
                <div className={cx('dropdown-examSortMethod')}>
                  <div className={cx('dropdown-arrow-area', 'small-arrow')}>
                    <Image className={cx('dropdown-image')} src={'/img/target/list_select.png'} />
                  </div>
                  <Dropdown
                    // className={cx('dropdown-examSortMethod', dropDirection ? 'upward' : null)}
                    placeholder={
                      defineMessages(formatMessage({ id: 'ExamSearch_22', defaultMessage: '정렬' }))
                      // <Image src="/img/exam/list_select.png" />
                    }
                    floating
                    button
                    scrolling
                    options={sortedOptions}
                    onChange={examSearchProps.onSort}
                    icon={null}
                  />
                </div>
              </Tooltip>
              {/* --------------------------------- 필터 --------------------------------- */}
              <Tooltip
                classes={{
                  tooltip: 'tooltip',
                  tooltipOpen: filterExamArray.length + filterPCArray.length > 0 ? '' : 'close'
                }}
                title={tooltipInfo}
                placement="bottom">
                <div
                  className={cx(
                    'exam-dropdown-area',
                    filterExamArray.length + filterPCArray.length > 0 ? 'target-dropdown-area-border' : ''
                  )}>
                  <div className={cx('dropdown-arrow-area', 'small-arrow')}>
                    {filterExamArray.length + filterPCArray.length > 0 ? (
                      <div className={cx('number-box')}>{filterExamArray.length + filterPCArray.length}</div>
                    ) : (
                        <Image className={cx('dropdown-image')} src={'/img/target/list_select.png'} />
                      )}
                  </div>
                  <Popup
                    className={cx('filter-popup')}
                    trigger={
                      <div
                        className={cx(
                          'default-text',
                          filterExamArray.length + filterPCArray.length > 0 ? 'filter-length' : ''
                        )}>
                        {defineMessages(formatMessage({ id: 'Target_31', defaultMessage: '필터' }))}
                      </div>
                    }
                    on="click"
                    open={popupOpen}
                    onOpen={() => { examSearchProps.filterClose(), handlePopup(true) }}
                    onClose={() => { examSearchProps.filterClose(), handlePopup(false) }}
                    flowing
                    position="bottom center">
                    {/* <div
                      className={cx('switch-area')}
                      onClick={e => {
                        e.stopPropagation();
                      }}>
                      AND
                      <div className={cx('input-switch')}>
                        <Switch
                          className="switch"
                          classes={{
                            checked: 'checked'
                          }}
                          checked={!!(tempFilter['filterType'] === 'and')}
                          disabled={typeof tempFilter['filterType'] === 'undefined' ? true : false}
                          onClick={e => {
                            e.stopPropagation();
                            examSearchProps.onFilterType('filterType');
                          }}
                        />
                      </div>
                    </div> */}
                    <Grid centered divided columns={examType === 4 ? 1 : 2}>
                      <Grid.Column textAlign="left">{examFilterList}</Grid.Column>
                      {examType !== 4 ? <Grid.Column textAlign="left">{infectionFilterList}</Grid.Column> : null}
                    </Grid>
                    <Grid className={cx('bottom-options')}>
                      <Grid.Column className={cx(examType === 4 ? 'multi-row' : '')}>
                        <div className={cx('all-check-off')} onClick={examSearchProps.onFilterCancel}>
                          {defineMessages(formatMessage({ id: 'Target_32', defaultMessage: '모든 필터 해제' }))}
                        </div>
                        <div className={cx('inline-block')}>
                          <Button className={cx('button-border', 'button')} onClick={() => { examSearchProps.cancleCheck(), handlePopup(false) }}>
                            {defineMessages(formatMessage({ id: 'TargetDetail_7', defaultMessage: '취 소' }))}
                          </Button>
                          <Button className={cx('button-brand', 'button')} onClick={() => { examSearchProps.executeFilter(), handlePopup(false) }}>
                            {defineMessages(formatMessage({ id: 'TargetDetail_37', defaultMessage: '확 인' }))}
                          </Button>
                        </div>
                      </Grid.Column>
                    </Grid>
                  </Popup>
                </div>
              </Tooltip>
              <div className={cx('input-search-area')}>
                <Input
                  className={cx('search-input')}
                  size="mini"
                  placeholder={defineMessages(formatMessage({ id: 'ExamSearch_17', defaultMessage: '검색' }))}
                  onKeyPress={examSearchProps.onSearch}
                  onChange={this.handleChangeSearchText}
                  // value={examSearchProps.searchText}
                  ref={searchTextRef}
                />
                <Button
                  id="bt-searchExam"
                  fontColor="#757575"
                  size="mini"
                  icon={<img src="/img/exam/list_search.png" />}
                  onClick={examSearchProps.onSearch}
                />
              </div>
              <Tooltip
                title={defineMessages(formatMessage({ id: 'Target_13', defaultMessage: '필터 해제' }))}
                placement="top">
                <IconButton className={cx('bt-filterCancel')} onClick={examSearchProps.onFilterCancel}>
                  <Image src={'/img/table/btn_filter' + (isFiltered ? '_active' : '') + '.png'} />
                </IconButton>
              </Tooltip>
            </div>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ExamSearch));



// WEBPACK FOOTER //
// ./src/script/components/exam/ExamSearch.js